import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Form, Modal } from "react-bootstrap";
import {
  downloadSubjectOutcomeTemplate,
  getCourseSubjectAndOutcomeData,
  noFileAlert,
  nonExcelFormatAlert,
  resultAlert
} from "../../../../../_helpers/Helpers";
import * as actions from "../../_redux/course-subjects/CourseSubjectsAction";
import { useCourseSubjectsUIContext } from "./CourseSubjectsUIContext";

export function ImportFromExcel({
  showDialog,
  closeDialog
}) {
  // Course Subjects UI Context
  const courseSubjectsUIContext = useCourseSubjectsUIContext();
  const courseSubjectsUIProps = useMemo(() => {
    return {
      queryParams: courseSubjectsUIContext.queryParams
    };
  }, [courseSubjectsUIContext]);

  // Course Subjects Redux state
  const dispatch = useDispatch();

  /** Belli Bir Ders Konusu ve Konulara Ait Kazanım Listesini Belli Bir Excel Dosyasından Yükler */
  const importFromExcel = (file) => {
    if (!file) {
      noFileAlert();
      return;
    }
    if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      nonExcelFormatAlert();
      return;
    }
    const reader = new FileReader();
    reader.onload = async function(e) {
      const values = {
        entityId: courseSubjectsUIProps.queryParams.filter.courseId,
        datas: await getCourseSubjectAndOutcomeData(e)
      };          
      dispatch(actions.saveCourseSubjectAndOutcomes(values)).then((result) => onResult(result));
    }
    reader.readAsArrayBuffer(file);
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
  
    if (isSuccess) {
      setTimeout(() => {
        closeDialog();
        dispatch(actions.getCourseSubjects(courseSubjectsUIProps.queryParams));
      }, 2500);
    }
  };

  const [file, setFile] = useState();

  return (
    <Modal
      show={showDialog}
      onHide={closeDialog}
      aria-labelledby=""
    >
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title id="">Excelden Konu Kazanımı Yükleme</Modal.Title>
      </Modal.Header>

      <Form onSubmit={e => {
        e.preventDefault();
        importFromExcel(file);
      }}>
        <Modal.Body>
          <div className="text-center">
            <input type="file" accept=".xlsx" onChange={e => setFile(e.target.files[0])} />
          </div>          
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            type="button"
            className="btn btn-sm btn-info"
            onClick={downloadSubjectOutcomeTemplate}
          >
            Şablon İndir
          </button>
          <button
            type="submit"
            className="btn btn-sm btn-primary"
          >
            Yükle
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={closeDialog}
          >
            Vazgeç
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}